import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState = {
  mapObject: {},
  polylines: [],
}

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setMapObject: (state, action: PayloadAction<any>) => {
      state.mapObject = action.payload
    },
    setPolyline: (state, action: PayloadAction<any>) => {
      state.polylines = action.payload
    },
  },
})
export const mapAction = mapSlice.actions
export default mapSlice
